<template>
  <footer class="footer">
    <div class="content has-text-centered">
      <div class="container">
        <hr />
        <p>
          © 2020 Jake Offermann
        </p>
        <a href="https://www.instagram.com/offworldart/" target="_blank">
          <b-button
            type="is-dark"
            icon-right="instagram"
            class="has-margin-right-5 -is-instagram"
          />
        </a>
        <a href="https://www.linkedin.com/in/jake-offermann/" target="_blank">
          <b-button
            type="is-dark"
            icon-right="linkedin"
            class="has-margin-left-5 -is-instagram"
          />
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter"
};
</script>

<style scoped lang="scss">
.-app-footer {
  border-top: 1px solid #eeeeee;
}
</style>
